export default __webpack_public_path__ + "static/media/55.92b3f2fa.gif";